import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
}

export default function NewsCard({ item }: NewsCardProps) {
  return (
    <article className="group">
      <Link
        to={`/news/${item.id}`}
        className="flex flex-col gap-4 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-colors hover:border-primary-200 md:flex-row md:items-center md:p-4"
      >
        <div className="h-44 w-full shrink-0 overflow-hidden rounded-md bg-secondary-100 md:h-28 md:w-44">
          <img
            src={item.cover}
            alt={`${item.title} 配图`}
            title={`${item.title} 百合影视资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-calendar-line" />
              </span>
              {item.date}
            </span>
            <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
              资讯
            </span>
          </div>
          <h3 className="mt-2 text-sm font-semibold leading-snug text-foreground-950 transition-colors line-clamp-2 group-hover:text-primary-600 md:text-base">
            {item.title}
          </h3>
          <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-2 md:text-sm">
            {item.summary}
          </p>
        </div>
      </Link>
    </article>
  );
}